// extracted by mini-css-extract-plugin
export default {"bubble":"_2VjM7","content":"rxsCl","triangleWrapper":"MZhnV","arrowleft":"x4ioN","triangle":"FglUM"};